<template>
  <div class="carfax-container" data-cy="powered-by-bar">
    <span>{{ $t('message.trade.poweredByBB') }}</span>
    <img :src="require('@/assets/CFC-Logo.png')" alt="Carfax" class="carfax-logo" />
  </div>
</template>

<script>
import log from '@/services/log';

export default {
  async mounted() {
    try {
      const payload = {
        elementRendered: 'carfax_logo',
      };
      await this.$store.dispatch('metrics/logModalElementRendered', payload);
    } catch (error) {
      log('Error in logging element rendered', error);
    }
  },
};
</script>

<style scoped lang="scss">
.carfax-container {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background-color: $primary-light-background2;
  border-radius: 8px;
  padding: 4px 10px;
  width: 100%;
  height: 26px;
  box-sizing: border-box;
}

.carfax-logo {
  margin-left: 7px;
  width: 90.95px;
}

span {
  font-size: 14px;
  font-weight: 400;
  color: $primary-dark-text;
  line-height: 18px;
}

.carfax-msg {
  font-size: 1.25rem;
}
</style>
